export default "__VITE_ASSET__ljOsKqWw__"